/* ANORA BLANC: slow, smooth crossfade cycling through all product gallery images on card hover (desktop) / touch (mobile). */
(function () {
  var CYCLE_INTERVAL_MS = 2500;
  var states = new WeakMap();

  function hydrate(image) {
    if (image.dataset.srcset && !image.srcset) {
      image.srcset = image.dataset.srcset;
    }
    if (image.dataset.sizes && !image.sizes) {
      image.sizes = image.dataset.sizes;
    }
  }

  function getState(container) {
    var state = states.get(container);
    if (state) return state;

    var images = Array.prototype.slice.call(container.querySelectorAll('.card__cycle-image'));
    state = { images: images, index: 0, intervalId: null };
    states.set(container, state);
    return state;
  }

  function start(container) {
    var state = getState(container);
    if (state.intervalId || state.images.length < 2) return;

    state.images.forEach(hydrate);

    state.intervalId = window.setInterval(function () {
      var nextIndex = (state.index + 1) % state.images.length;
      state.images[state.index].classList.remove('is-active');
      state.images[nextIndex].classList.add('is-active');
      state.index = nextIndex;
    }, CYCLE_INTERVAL_MS);
  }

  function stop(container) {
    var state = states.get(container);
    if (!state || !state.intervalId) return;

    window.clearInterval(state.intervalId);
    state.intervalId = null;
    state.images.forEach(function (image, i) {
      image.classList.toggle('is-active', i === 0);
    });
    state.index = 0;
  }

  function init() {
    var containers = document.querySelectorAll('[data-gallery-cycle]');
    containers.forEach(function (container) {
      container.addEventListener('mouseenter', function () {
        start(container);
      });
      container.addEventListener('mouseleave', function () {
        stop(container);
      });
      container.addEventListener(
        'touchstart',
        function () {
          containers.forEach(function (other) {
            if (other !== container) stop(other);
          });
          start(container);
        },
        { passive: true }
      );
    });

    document.addEventListener(
      'touchstart',
      function (event) {
        containers.forEach(function (container) {
          if (!container.contains(event.target)) stop(container);
        });
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
